import { connect } from 'react-redux'

import {
    resetCollaborativeIndexationCreationInvalidField,
    updateCollaborativeIndexationGregorianDate,
} from '../../../../../../../redux/collaborativeIndexations/actions'
import {
    getCollaborativeIndexationCreationFields,
    isCollaborativeIndexationCreationInvalidField,
} from '../../../../../../../redux/collaborativeIndexations/selectors'
import Gregorian from './Gregorian.jsx'

const mapDispatchToProps = (dispatch, getState) => ({
    updateFieldValue: (field, value) => dispatch(updateCollaborativeIndexationGregorianDate(field, value)),
    resetInvalidField: (field) => dispatch(resetCollaborativeIndexationCreationInvalidField(field)),
})

const mapStateToProps = state => ({
    fields: getCollaborativeIndexationCreationFields(state),
    isInvalidField: (field) => isCollaborativeIndexationCreationInvalidField(state, field),
})

export const GregorianContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(Gregorian)
